import {DialogProgrammatic} from "buefy";
import {$t} from "./translations";

const Dialog = new DialogProgrammatic()

export async function alert(message) {
  return new Promise((resolve, reject) => {
    Dialog.alert({
      message,
      onCancel: () => resolve(true), // closing by clicking away / cross
      onConfirm: () => resolve(true) // closing by clicking OK
    })
  })
}

export async function prompt(message :string, defaultValue :string, dataTestId ?:string) :Promise<string> {
  return new Promise((resolve, reject) => {
    Dialog.prompt({
      message,
      inputAttrs: {
        value: defaultValue,
        "data-test-id": dataTestId
      },
      confirmText: $t('ok'),
      cancelText: $t('cancel'),
      onCancel: () => reject(),
      onConfirm: (value) => resolve(value)
    })
  })
}


export async function confirm(message :string, confirmText :string) :Promise<boolean> {
  return new Promise((resolve, reject) => {
    Dialog.confirm({
      message,
      confirmText: confirmText ?? $t('ok'),
      cancelText: $t('cancel'),
      onCancel: () => resolve(false),
      onConfirm: (value) => resolve(true)
    })
  })
}

export default {alert, confirm, prompt}
